import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Comece Aqui', path: '/comece-aqui' },
    { name: 'Notícias', path: '/noticias' },
    { name: 'Tutoriais', path: '/tutoriais' },
    { name: 'Artigos', path: '/artigos' },
    { name: 'Ferramentas', path: '/ferramentas' },
    { name: 'Doar', path: '/doar' },
    { name: 'Sobre', path: '/sobre' },
    { name: 'Contato', path: '/contato' },
  ];

  return (
    <header className="backdrop-blur-xl bg-background/80 border-b border-border/50 sticky top-0 z-50" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-background to-muted p-0.5 shadow-lg">
              <img 
                src="https://static.prod-images.emergentagent.com/jobs/d8a3ca16-6102-4289-b1d3-e802026d4bf5/images/679ce8c30dabaa92464bb2d013173cc342e4a01a6e6bb4cbb630fbbc2efb26bc.png"
                alt="Bitcoin Atlas Logo"
                className="w-full h-full object-contain rounded-full"
              />
            </div>
            <div>
              <h1 className="text-xl font-bold tracking-tight">Bitcoin Atlas</h1>
              <p className="text-xs text-muted-foreground">Navegando o mundo do Bitcoin</p>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground rounded-sm transition-colors"
                data-testid={`nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <button
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {mobileMenuOpen && (
          <nav className="lg:hidden pb-4 flex flex-col gap-2" data-testid="mobile-menu">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground rounded-sm transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};